/** The single set of canvas keys (which UI renders). Components live in rovodal-host. */
export const RovodalCanvasKeys = {
	jiraAdminAgentBlastRadiusCanvas: 'jira-admin-agent-blast-radius-canvas',
} as const;

export type RovodalCanvasKeys = (typeof RovodalCanvasKeys)[keyof typeof RovodalCanvasKeys];
